import { CODInput } from "../../ui/CODinput";
import { Select } from "../../ui/Select";

const buttonStyles = {
  save: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "none",
    background: "#07b1b0",
    color: "#fff",
    cursor: "pointer",
  },
  cancel: {
    padding: "8px 16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#fff",
    color: "#333",
    cursor: "pointer",
  },
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
  marginTop: "10px",
};

const AddCompanyTypeForm = ({ formData, onChange, onSubmit, onCancel }) => {
  return (
    <form>
      <CODInput
        label="Country"
        type="text"
        name="country"
        value={formData.country || ""}
        onChange={onChange}
        required
      />
      <CODInput
        label="Company Type"
        type="text"
        name="companyType"
        value={formData.companyType || ""}
        onChange={onChange}
        required
      />
      {/* <Select 
        label="Diligence"
        name="diligence"
        value={formData.diligence || "None"}
        onChange={onChange}
        options={[
            { value: "Standard", display_value: "Standard" },
            { value: "Enhanced", display_value: "Enhanced" },
            { value: "Simplified", display_value: "Simplified" }
        ]}
        required
      /> */}
    

      <div style={buttonContainerStyle}>
        <button type="submit" style={buttonStyles.save} onClick={onSubmit}>
          Save
        </button>
        <button type="button" onClick={onCancel} style={buttonStyles.cancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddCompanyTypeForm;
